import { render, staticRenderFns } from "./PageCard.vue?vue&type=template&id=a783ded8&"
import script from "./PageCard.vue?vue&type=script&lang=js&"
export * from "./PageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports